import { Modal, ModalClose } from '@mui/joy';
import type { ReactNode } from 'react';

import { GlassModalContainer } from './glassModal.style';

type GlassModalProps = {
  open: boolean;
  onClose?: () => void;
  header?: {
    title: string;
    description?: string;
  };
  className?: string;
  children: ReactNode;
};
/** @deprecated */
export const GlassModal = ({
  children,
  open,
  header,
  onClose,
  className
}: GlassModalProps) => (
  <Modal
    aria-describedby="modal-desc"
    aria-labelledby="modal-title"
    onClose={onClose}
    open={open}
    slotProps={{
      backdrop: {
        sx: {
          backdropFilter: 'blur(2px)',
          backgroundColor: 'rgba(0, 0, 0, 0.2);'
        }
      }
    }}
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'transparent',
      border: 'none',
      boxShadow: 'none'
    }}
  >
    <GlassModalContainer className={className}>
      <ModalClose />
      {header && (
        <section className="w-full items-center p-4 py-2">
          <h1 className="font-semibold">{header.title}</h1>
        </section>
      )}
      {children}
    </GlassModalContainer>
  </Modal>
);
